import { ref, computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import colorToHex from '@/helpers/colorToHex.js'

export function useMakePopupContent () {
    const translaterStore = useTranslaterStore()

    const popupElement = ref(null)
    const popupElementText = ref(null)
    const popupElementLat = ref(null)
    const popupElementLng = ref(null)
    const popupElementAreas = ref(null)
    const popupElementAreasItem = ref(null)
    
    const getTranslate = computed(() => translaterStore.getTranslate)

    function makePopupContent(location, areas) {
        popupElement.value = document.createElement('div')
        popupElement.value.classList.add('uta-areas-popup')

        popupElementText.value = document.createElement('div')
        popupElementText.value.classList.add('uta-areas-popup__text')

        popupElementLat.value = document.createElement('div')
        popupElementLat.value.classList.add('uta-areas-popup__text-latlng')
        popupElementLat.value.textContent = `${getTranslate.value.AREA_LAT}: ${location[1]}`
            
        popupElementLng.value = document.createElement('div')
        popupElementLng.value.classList.add('uta-areas-popup__text-latlng')
        popupElementLng.value.textContent = `${getTranslate.value.AREA_LNG}: ${location[0]}`
        
        popupElementAreas.value = document.createElement('div')
        popupElementAreas.value.classList.add('uta-areas-popup__areas')
        popupElementAreas.value.textContent = `${getTranslate.value.AREAS}:`       
        
        popupElementText.value.appendChild(popupElementLat.value)
        popupElementText.value.appendChild(popupElementLng.value)
        popupElementText.value.appendChild(popupElementAreas.value)

        areas.forEach(area => {
            popupElementAreasItem.value = document.createElement('div')
            popupElementAreasItem.value.classList.add('uta-areas-popup__areas-item')
            
            if(area.type == 'line'){
                popupElementAreasItem.value.innerHTML = `
                    <a href="/areas/${area.uuid}" class="uta-areas-popup__areas-item_link">${area.name}</a>
                    <div class="uta-areas-popup__areas-item-color" style="background-color: ${colorToHex(area.options.strokeColor)};"></div>
                `
            } else {
                popupElementAreasItem.value.innerHTML = `
                    <a href="/areas/${area.uuid}" class="uta-areas-popup__areas-item_link">${area.name}</a>
                    <div class="uta-areas-popup__areas-item-color" style="background-color: ${colorToHex(area.options.fillColor)};"></div>
                `
            }
    
            popupElementAreas.value.appendChild(popupElementAreasItem.value)
        })

        const closeIconElement = document.createElement('button')
        closeIconElement.classList.add('uta-areas-popup__close', 'uta-areas-close_icon')

        popupElement.value.appendChild(popupElementText.value)
        popupElement.value.appendChild(closeIconElement)

        return popupElement.value
    }

    return {
        makePopupContent
    }
}